import {
  useChatStore,
} from "@/stores"
import type {
  ChatMessage,
} from "@/types";
export function handleGlobalChat(params: ChatMessage) {
  const chatStore = useChatStore();
  chatStore.receiveMessage(params, "global");
}
